import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService, IUser } from '../services';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard {
  constructor(
    private router: Router,
    private authorize: AuthService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authorize.getUser().pipe(
      map((user: IUser) => {
        const roleFound = route.data?.roles.some((role: string) =>
          Array.isArray(user.role) ? user.role.some((userRole: string) => userRole === role) : user.role === role,
        );

        if (user.role && !roleFound) {
          this.router.navigate(['error']);
        }

        return true;
      }),
    );
  }
}
